import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Segment, Grid, Accordion } from "semantic-ui-react";
import _ from "lodash";
import BusinessUccNimbusRecordHeader from "../searchresults/BusinessUccNimbusRecordHeader";
import BusinessBccNimbusItemRecordFullDetail from "../searchresults/BusinessBccNimbusItemRecordFullDetail";
import getPrintCaseHeader from "./PrintCaseHeader";

class BusinessUccNimbusReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedReportId: null,
    };
  }

  onSelectReport = (selectedReportId) => {
    this.state = { selectedReportId };
  };

  render() {
    const results = [];
    if (
      this.props.reportData !== undefined &&
      this.props.reportData !== null &&
      this.props.reportData !== ""
    ) {
      const record = _.get(
        this.props.reportData,
        `${Object.keys(this.props.reportData)[0]
        }.UCCFiling[0]`
      );

      if (record !== undefined) {
        const header = (
          <Table.Row key={`Business_Ucc_Header_Row_1`}>
            <Table.Cell>
              <BusinessUccNimbusRecordHeader
                key={`Business_Ucc_Header_Table_1`}
                node={record}
                index={1}
                onSelectReport={this.onSelectReport}
                {...this.props}
                companyName={_.get(
                  record,
                  "debtors[0].debtor[0].businessName[0]._",
                  ""
                )}
                userAccount={this.props.userAccount}
              />
            </Table.Cell>
          </Table.Row>
        );
        const body = (
          <Table.Row key={`Business_Ucc_Body_Table_Row_1`}>
            <Table.Cell>
              <BusinessBccNimbusItemRecordFullDetail
                key={`Business_Ucc_Body_Table_1`}
                node={record}
                index={1}
                {...this.props}
              />
            </Table.Cell>
          </Table.Row>
        );
        results.push(header);

        results.push(body);
      }
    }

    return (
      <Segment key="tabContent1" attached id={`report`}>
        <Grid columns={2} stackable>
          <Grid.Row>
            <Grid.Column width={16}>
              <Table className={`no-print`}>
                <Table.Body>{getPrintCaseHeader(this.props)}</Table.Body>
              </Table>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <Accordion fluid styled>
                <Table>
                  <Table.Body>
                    <Table.Row>
                      <Table.HeaderCell
                        className="report-section-header"
                        colSpan={6}
                      >
                        Business UCC
                      </Table.HeaderCell>
                    </Table.Row>
                    {results}
                  </Table.Body>
                </Table>
              </Accordion>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

function mapStateToProps(state) {
  return { userAccount: state.userAccount };
}

export default connect(mapStateToProps, null)(BusinessUccNimbusReport);



// WEBPACK FOOTER //
// ./src/components/reports/BusinessUccNimbusReport.js